export const BurgerMenuDataLayerLabel = {
    myFavorites: 'my favourites',
    followOrder: 'layer_track_my_order',
    helpAndContact: 'help and contact',
};
